import { render, staticRenderFns } from "./ExportSlovenianPensioners.vue?vue&type=template&id=0ca1433c&scoped=true&"
import script from "./ExportSlovenianPensioners.vue?vue&type=script&lang=js&"
export * from "./ExportSlovenianPensioners.vue?vue&type=script&lang=js&"
import style0 from "./ExportSlovenianPensioners.vue?vue&type=style&index=0&id=0ca1433c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0ca1433c",
  null
  
)

export default component.exports